import { produce } from "immer";
import { useState, useEffect } from "react";
import FormFieldWithLabel from "../FormFieldWithLabel/FormFieldWithLabel";

export default function QIConditionalInput({
  currentQuestionViewIndex,
  childIndex,
  quizQuestions,
  setQuizQuestions,
}) {
  const [inputErrorMessage, setInputErrorMessage] = useState("");
  const [inputValue, setInputValue] = useState(
    quizQuestions[currentQuestionViewIndex].children[childIndex].inputValue
  );

  function editInputValue(text) {
    setInputValue(text);
    const isInputError = quizQuestions[currentQuestionViewIndex].children[
      childIndex
    ].checkInputError?.call(quizQuestions, text);
    const inputErrorMessage =
      quizQuestions[currentQuestionViewIndex].children[childIndex]
        .inputErrorMessage;
    setQuizQuestions(
      produce((quizQuestionsDraft) => {
        const currentQuestionDraft =
          quizQuestionsDraft[currentQuestionViewIndex].children[childIndex];
        //why are we not saving the value if there is an input error??
        currentQuestionDraft.inputValue = isInputError ? "" : text;
        currentQuestionDraft.inputError = isInputError;
      })
    );
    setInputErrorMessage(isInputError ? inputErrorMessage : "");
  }

  useEffect(() => {
    const inputError =
      quizQuestions[currentQuestionViewIndex].children[childIndex].inputError;
    const inputErrorMessage =
      quizQuestions[currentQuestionViewIndex].children[childIndex]
        .inputErrorMessage;
    setInputErrorMessage(inputError ? inputErrorMessage : "");
  }, [quizQuestions]);

  const { rows, cols } = quizQuestions[currentQuestionViewIndex].children[
    childIndex
  ].inputLabel?.includes("Notes")
    ? { rows: 3, cols: 3 }
    : { rows: 0, cols: 0 };

  return (
    <div className="container">
      <FormFieldWithLabel
        label={
          quizQuestions[currentQuestionViewIndex].children[childIndex]
            .inputLabel
        }
        type="text"
        id={
          quizQuestions[currentQuestionViewIndex].children[childIndex]
            .inputLabel
        }
        placeholder=""
        value={inputValue}
        onChange={(e) => {
          editInputValue(e.target.value);
        }}
        errorMessage={inputErrorMessage}
        r={rows}
        c={cols}
        required={
          quizQuestions[currentQuestionViewIndex].children[childIndex]
            .inputRequired
        }
      />
    </div>
  );
}
